import { useTourneyAutoPlay, useTourneyId } from '@/src/hooks/data/useGameTable'
import styles from './TourneyAutoPlayCTA.module.css'
import React, { useState } from 'react'
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import { Loader } from 'lucide-react';

export default function TourneyAutoPlayCTA({ tempTableId }) {
    const tourneyAutoPlay = useTourneyAutoPlay(tempTableId);
    const tourneyId = useTourneyId(tempTableId);
    const [loading, setLoading] = useState(false);
    const { sendDisableAutoPlay } = useGameSocket(tempTableId);

    const handleDisableAutoPlay = () => {
        if (loading) return;
        setLoading(true);
        sendDisableAutoPlay(tourneyId);
    }

    return tourneyAutoPlay ? (
        <div className={styles.tourneyAutoPlayNotice}>
            <div className={styles.tourneyAutoPlayNoticeText}>
                You seem to be away. Auto play is on.
            </div>
            <div onClick={handleDisableAutoPlay} className={styles.tourneyAutoPlayNoticeButton}>
                {loading ? <Loader className={styles.loader} /> : "I'm back"}
            </div>
        </div>
    ) : null;
}
